module.exports = "<div class=\"full-page\">\n    <p class=\"container-text-title\">The selected page does not exist.</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/spina-me/source/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = 1